var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthAndSafety = function SvgHealthAndSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13H8v-3h2.5V7.5h3V10H16v3h-2.5v2.5h-3zM12 2 4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5z"
  })));
};
export { SvgHealthAndSafety as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgMTNIOFYxMEgxMC41VjcuNUgxMy41VjEwSDE2VjEzSDEzLjVWMTUuNUgxMC41VjEzWk0xMiAyTDQgNVYxMS4wOUM0IDE2LjE0IDcuNDEgMjAuODUgMTIgMjJDMTYuNTkgMjAuODUgMjAgMTYuMTQgMjAgMTEuMDlWNUwxMiAyWiIgLz4KPC9zdmc+Cg==";